/* =====================================================================
   INDUCTION HARDWARE — ENERGY UI CONTROLLER
   Drives the modules off ONE shared state + ONE model:
     [data-ih-thermo]     kitchen thermometer / comfort
     [data-ih-costcalc]   lifetime cost calculator
     [data-ih-costteaser] buy-column savings chip
   Re-entrant: safe to call again after a Shopify section re-render.
===================================================================== */
function ihEnergyInit() {
  'use strict';
  var M = window.IHEnergyModel;
  if (!M) return;

  var calc = document.querySelector('[data-ih-costcalc]');
  var thermo = document.querySelector('[data-ih-thermo]');
  var teaser = document.querySelector('[data-ih-costteaser]');
  if (!calc && !thermo) return;

  var host = calc || thermo;

  function attr(el, name) { var v = el && el.getAttribute(name); v = parseFloat(v); return isFinite(v) ? v : null; }
  var override = {
    elecRate: attr(host, 'data-elec-rate'),
    gasRate: attr(host, 'data-gas-rate'),
    gasFixed: attr(host, 'data-meter-fee'),
    cooktopGasEff: attr(host, 'data-gas-eff'),
    cooktopIndEff: attr(host, 'data-ih-eff'),
    acCOP: attr(host, 'data-cop'),
    repairsPerYear: attr(host, 'data-repairs')
  };
  Object.keys(override).forEach(function (k) { if (override[k] === null) delete override[k]; });
  M.configure(override);

  var S = window.__ihEnergyState;
  if (!S) {
    S = window.__ihEnergyState = {
      skuId: host.getAttribute('data-sku') || 'S-IR48',
      skuLabel: host.getAttribute('data-sku-label') || '',
      gasPeer: attr(host, 'data-gas-equiv-price') || 0,
      gasLife: attr(host, 'data-gas-life') || 0,
      gasLabel: host.getAttribute('data-gas-equiv-label') || '',
      rateId: 'nevada',
      elec: M.RATES.nevada.elec,
      gas: M.RATES.nevada.gas,
      gasFixed: M.RATES.nevada.gasFixed,
      sessionsPerWeek: 10,
      years: 20,
      closeAccount: false,
      kitchen: 'standard',
      hood: 'sometimes',
      baseF: 72,
      acMonths: 4,
      minutes: null
    };
  }

  /* The model only carries physics for SKUs it has an entry for, and M.sku()
     falls back to S-IR48 so the maths still runs for the rest. That fallback
     must never NAME the listing: on a 30" Pro range, a drop-in cooktop or the
     outdoor grill it introduced the product as a 48" Luxury Series range.
     data-sku-label is the listing's own title, resolved in Liquid by
     snippets/ih-energy-sku, and is used whenever the SKU is unknown here. */
  function skuKnown() {
    for (var i = 0; i < M.SKUS.length; i++) { if (M.SKUS[i].id === S.skuId) return true; }
    return false;
  }
  function skuName(entry) {
    return skuKnown() ? entry.label : (S.skuLabel || entry.label);
  }

  function usd(n, cents) {
    var neg = n < 0;
    var v = Math.abs(n);
    var body = cents
      ? v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : Math.round(v).toLocaleString('en-US');
    return (neg ? '−' : '') + '$' + body;
  }
  function num(n, d) { return Number(n).toLocaleString('en-US', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
  function degF(n) { return n.toFixed(1) + '°'; }
  function set(scope, sel, txt) { var el = scope.querySelector(sel); if (el) el.textContent = txt; }
  function setAll(scope, sel, txt) { scope.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }

  function placeDot(el, x, y, vbW, vbH) {
    if (!el) return;
    el.style.left = ((x / vbW) * 100).toFixed(3) + '%';
    el.style.top = ((y / vbH) * 100).toFixed(3) + '%';
    el.style.display = '';
  }

  function renderThermo() {
    if (!thermo) return;
    var t = M.thermal(S);
    var a = M.annual(S);
    var se = t.session;

    setAll(thermo, '[data-th-sku]', skuName(t.sku));
    set(thermo, '[data-th-gas-f]', degF(t.gasNowF));
    set(thermo, '[data-th-ih-f]', degF(t.indNowF));
    set(thermo, '[data-th-delta]', (t.gasNowF - t.indNowF).toFixed(1) + '°');
    set(thermo, '[data-th-peak-gas]', degF(t.gasPeakF));
    set(thermo, '[data-th-peak-ih]', degF(t.indPeakF));
    set(thermo, '[data-th-base]', degF(t.baseF));
    set(thermo, '[data-th-cook]', Math.round(t.cookMinutes) + ' min');

    var LO = 66, HI = 100;
    function pct(f) { return Math.max(0, Math.min(100, ((f - LO) / (HI - LO)) * 100)); }
    var gf = thermo.querySelector('[data-th-fill="gas"]');
    var nf = thermo.querySelector('[data-th-fill="ih"]');
    if (gf) gf.style.height = pct(t.gasNowF).toFixed(2) + '%';
    if (nf) nf.style.height = pct(t.indNowF).toFixed(2) + '%';

    set(thermo, '[data-th-gas-btu]', num(se.gasRoom));
    set(thermo, '[data-th-ih-btu]', num(se.indRoom));
    set(thermo, '[data-th-ratio]', (se.gasRoom / Math.max(se.indRoom, 1)).toFixed(1) + '×');
    var gg = thermo.querySelector('[data-th-gauge="gas"]');
    var ng = thermo.querySelector('[data-th-gauge="ih"]');
    if (gg) gg.style.width = '100%';
    if (ng) ng.style.width = Math.max(2, (se.indRoom / se.gasRoom) * 100).toFixed(1) + '%';

    set(thermo, '[data-th-ac-kwh]', num(a.acKwh) + ' kWh');
    set(thermo, '[data-th-ac-cost]', usd(a.acCost, true));
    set(thermo, '[data-th-ac-life]', usd(a.acCost * S.years));
    setAll(thermo, '[data-th-ac-months]', S.acMonths + (S.acMonths === 1 ? ' month' : ' months'));

    var svg = thermo.querySelector('[data-th-chart]');
    if (svg) {
      var W = 320, H = 150, PT = 10, PB = 18;
      var yLo = t.baseF - 1.5;
      var yHi = Math.max(t.gasPeakF + 2, t.baseF + 8);
      var X = function (min) { return (min / t.spanMinutes) * W; };
      var Y = function (f) { return (H - PB) - ((f - yLo) / (yHi - yLo)) * (H - PB - PT); };
      var line = function (curve) {
        return curve.map(function (p) { return X(p.h * 60).toFixed(1) + ',' + Y(p.f).toFixed(1); }).join(' ');
      };
      var gl = svg.querySelector('[data-th-line="gas"]');
      var il = svg.querySelector('[data-th-line="ih"]');
      if (gl) gl.setAttribute('points', line(t.gasCurve));
      if (il) il.setAttribute('points', line(t.indCurve));

      var baseLine = svg.querySelector('[data-th-baseline]');
      if (baseLine) { baseLine.setAttribute('y1', Y(t.baseF).toFixed(1)); baseLine.setAttribute('y2', Y(t.baseF).toFixed(1)); }
      var off = svg.querySelector('[data-th-cookoff]');
      if (off) { off.setAttribute('x1', X(t.cookMinutes).toFixed(1)); off.setAttribute('x2', X(t.cookMinutes).toFixed(1)); off.setAttribute('y2', (H - PB).toFixed(1)); }
      var scrub = svg.querySelector('[data-th-scrubline]');
      if (scrub) { scrub.setAttribute('x1', X(t.minutes).toFixed(1)); scrub.setAttribute('x2', X(t.minutes).toFixed(1)); scrub.setAttribute('y2', (H - PB).toFixed(1)); }
      placeDot(thermo.querySelector('[data-th-dot="gas"]'), X(t.minutes), Y(t.gasNowF), 320, H);
      placeDot(thermo.querySelector('[data-th-dot="ih"]'), X(t.minutes), Y(t.indNowF), 320, H);
      set(thermo, '[data-th-yhi]', Math.round(yHi) + '°');
      set(thermo, '[data-th-ylo]', Math.round(yLo) + '°');
      set(thermo, '[data-th-xmax]', Math.round(t.spanMinutes) + ' min');
    }

    setAll(thermo, '[data-th-minutes-out]', Math.round(t.minutes) + ' min in');
    set(thermo, '[data-th-base-out]', Math.round(S.baseF) + '°F');
    set(thermo, '[data-th-vent]', num(t.ventCfm) + ' CFM');
    set(thermo, '[data-th-capture]', Math.round(se.capture * 100) + '%');
  }

  function renderCalc() {
    if (!calc) return;
    var L = M.lifetime(S);
    var a = L.annual;
    var se = a.session;
    var Y = L.years;

    set(calc, '[data-cc-total]', usd(Math.abs(L.net)));
    set(calc, '[data-cc-total-label]', L.net >= 0 ? 'Induction comes out ahead by' : 'Gas comes out ahead by');
    set(calc, '[data-cc-total-sub]', 'over ' + Y + ' years with a ' + skuName(L.sku));

    var crossEl = calc.querySelector('[data-cc-cross]');
    if (crossEl) {
      if (L.crossover && L.crossover > 1) {
        crossEl.textContent = 'Breaks even in year ' + L.crossover + '. Fuel alone never gets you there — the meter charge, the cooling load and the range you never re-buy do.';
      } else if (L.crossover === 1) {
        crossEl.textContent = 'Ahead from year one on these settings.';
      } else {
        crossEl.textContent = 'On these settings gas stays cheaper for the whole ' + Y + ' years. Cheap gas, expensive power, and a horizon shorter than a gas range’s service life.';
      }
    }

    var rows = {
      fuel: L.rows.fuel,
      ac: L.rows.ac,
      meter: L.rows.fixed,
      replace: L.rows.repairs + L.rows.replace
    };
    Object.keys(rows).forEach(function (k) {
      var row = calc.querySelector('[data-cc-row="' + k + '"]');
      if (!row) return;
      if (k === 'meter') row.hidden = !L.closeAccount;
      var v = row.querySelector('[data-cc-val]');
      if (v) {
        v.textContent = usd(rows[k]);
        v.setAttribute('data-negative', rows[k] < 0 ? 'true' : 'false');
      }
      var n = row.querySelector('[data-cc-note]');
      if (!n) return;
      if (k === 'fuel') {
        n.textContent = rows[k] < 0
          ? num(a.gasTherms, 0) + ' therms/yr of gas at ' + usd(a.rates.gas, true) + '/therm is cheaper than ' + num(a.indKwh) + ' kWh at ' + (a.rates.elec * 100).toFixed(2) + '¢. Point-of-use fuel is not where induction wins — and we are not going to pretend otherwise.'
          : num(a.gasTherms, 0) + ' therms/yr at ' + usd(a.rates.gas, true) + '/therm vs ' + num(a.indKwh) + ' kWh/yr at ' + (a.rates.elec * 100).toFixed(2) + '¢.';
      }
      if (k === 'ac') n.textContent = num(a.acKwh) + ' kWh/yr of cooling to remove the flame’s waste heat, ' + S.acMonths + ' months a year.';
      if (k === 'meter') n.textContent = usd(a.rates.gasFixed, true) + '/mo customer charge, billed whether you cook or not.';
      if (k === 'replace') n.textContent = L.replacements + '× ' + L.gasLabel + ' at ' + usd(L.gasPeer) + ' over ' + Y + ' years (' + L.gasLife + '-yr service life), plus ' + usd(M.PHYS.repairsPerYear) + '/yr of out-of-warranty repair from year ' + M.PHYS.repairsStartYear + '. Yours: lifetime parts warranty.';
    });

    var svg = calc.querySelector('[data-cc-chart]');
    if (svg) {
      var W = 314, H = 120, PAD = 5;
      var max = Math.max(L.gasSeries[Y], L.indSeries[Y], 1);
      var px = function (y, v) {
        return ((y / Y) * W).toFixed(1) + ',' + ((H - PAD) - (v / max) * (H - PAD * 2)).toFixed(1);
      };
      var g = [], i = [];
      for (var y = 0; y <= Y; y++) { g.push(px(y, L.gasSeries[y])); i.push(px(y, L.indSeries[y])); }
      var gasLine = svg.querySelector('[data-cc-line-gas]');
      var ihLine = svg.querySelector('[data-cc-line]');
      if (gasLine) gasLine.setAttribute('points', g.join(' '));
      if (ihLine) ihLine.setAttribute('points', i.join(' '));

      var steps = svg.querySelectorAll('[data-cc-step]');
      var si = 0, r;
      for (r = L.gasLife; r <= Y && si < steps.length; r += L.gasLife) {
        var rx = (((r - 0.5) / Y) * W).toFixed(1);
        steps[si].setAttribute('x1', rx);
        steps[si].setAttribute('x2', rx);
        steps[si].setAttribute('y2', String(H - PAD));
        steps[si].setAttribute('visibility', 'visible');
        si++;
      }
      for (; si < steps.length; si++) steps[si].setAttribute('visibility', 'hidden');

      var crossLine = svg.querySelector('[data-cc-crossline]');
      if (crossLine) {
        if (L.crossover) {
          var cx = ((L.crossover / Y) * W).toFixed(1);
          crossLine.setAttribute('x1', cx);
          crossLine.setAttribute('x2', cx);
          crossLine.setAttribute('y2', String(H - PAD));
          crossLine.setAttribute('visibility', 'visible');
        } else {
          crossLine.setAttribute('visibility', 'hidden');
        }
      }

      [['gas', g], ['ih', i]].forEach(function (pair) {
        var last = pair[1][pair[1].length - 1].split(',');
        placeDot(calc.querySelector('[data-cc-dot="' + pair[0] + '"]'), parseFloat(last[0]), parseFloat(last[1]), 320, H);
      });

      set(calc, '[data-cc-key-cross]', L.crossover ? 'Break-even, year ' + L.crossover : 'No break-even in ' + Y + ' years');
      set(calc, '[data-cc-key-step]', si > 0 ? 'Gas re-buy, year ' + L.gasLife : 'Gas re-buy falls outside this horizon');
      set(calc, '[data-cc-chart-note]', 'Cumulative cost of ownership, ' + Y + ' years. The step is year ' + L.gasLife + ' — when ' + L.gasLabel + ' buys itself all over again at ' + usd(L.gasPeer) + '.');
      set(calc, '[data-cc-axis-max]', 'Year ' + Y);
    }

    var A = {
      elec: (a.rates.elec * 100).toFixed(2) + '¢ / kWh',
      gas: usd(a.rates.gas, true) + ' / therm delivered',
      fixed: usd(a.rates.gasFixed, true) + ' / month',
      gasEff: Math.round(se.gasEff * 100) + '%',
      indEff: Math.round(se.indEff * 100) + '%',
      useKwh: se.hours ? (M.sku(S.skuId).useKwh).toFixed(2) + ' kWh into the food over ' + Math.round(se.hours * 60) + ' min' : '',
      gasRoom: num(se.gasRoom) + ' BTU/hr',
      indRoom: num(se.indRoom) + ' BTU/hr',
      capture: Math.round(se.capture * 100) + '% hood capture',
      cop: 'COP ' + M.PHYS.acCOP + ', ' + S.acMonths + ' months of cooling',
      gasPeer: usd(L.gasPeer) + ' — ' + L.gasLabel + ', every ' + L.gasLife + ' years',
      repairs: usd(M.PHYS.repairsPerYear) + '/yr from year ' + M.PHYS.repairsStartYear,
      sessions: num(a.sessions) + ' sessions / year',
      volume: num((M.KITCHENS[S.kitchen] || M.KITCHENS.standard).volume) + ' ft³ kitchen'
    };
    Object.keys(A).forEach(function (k) { setAll(calc, '[data-a="' + k + '"]', A[k]); });

    set(calc, '[data-cc-freq-out]', S.sessionsPerWeek + '× / week');
    set(calc, '[data-cc-years-out]', Y + ' years');

    renderTeaser();
  }

  function renderTeaser() {
    if (!teaser) return;
    var base = {};
    Object.keys(S).forEach(function (k) { base[k] = S[k]; });
    base.sessionsPerWeek = 10; base.years = 20; base.closeAccount = true;
    var L = M.lifetime(base);
    var v = teaser.querySelector('[data-teaser-val]');
    if (v) v.textContent = usd(L.net);
    teaser.hidden = L.net <= 0;
  }

  function syncControls() {
    function put(scope, sel, v) {
      var el = scope && scope.querySelector(sel);
      if (el && el.value !== String(v)) el.value = String(v);
    }
    if (calc) {
      put(calc, '#ccSku', S.skuId);
      put(calc, '#ccRegion', S.rateId);
      put(calc, '#ccFreq', S.sessionsPerWeek);
      put(calc, '#ccYears', S.years);
      put(calc, '#ccElec', (S.elec * 100).toFixed(2));
      put(calc, '#ccGas', S.gas.toFixed(2));
      put(calc, '#ccFixed', S.gasFixed.toFixed(2));
      var chk = calc.querySelector('#ccElectrify');
      if (chk && chk.checked !== S.closeAccount) chk.checked = S.closeAccount;
      var cw = calc.querySelector('[data-cc-custom]');
      if (cw) cw.hidden = S.rateId !== 'custom';
    }
    if (thermo) {
      put(thermo, '#thKitchen', S.kitchen);
      put(thermo, '#thHood', S.hood);
      put(thermo, '#thBase', S.baseF);
      put(thermo, '#thAcMonths', S.acMonths);
      if (S.minutes != null) put(thermo, '#thMinutes', S.minutes);
    }
  }

  function renderAll() { syncControls(); renderThermo(); renderCalc(); }

  function bindSelect(scope, sel, apply) {
    var el = scope && scope.querySelector(sel);
    if (!el || el.__ihBound) return el;
    el.__ihBound = true;
    el.addEventListener('change', function () { apply(el.value); renderAll(); });
    return el;
  }
  function bindRange(scope, sel, apply) {
    var el = scope && scope.querySelector(sel);
    if (!el || el.__ihBound) return el;
    el.__ihBound = true;
    el.addEventListener('input', function () { apply(Number(el.value)); renderAll(); });
    return el;
  }

  if (calc && !calc.__ihBound) {
    calc.__ihBound = true;

    var skuSel = calc.querySelector('#ccSku');
    if (skuSel) { skuSel.value = S.skuId; }
    bindSelect(calc, '#ccSku', function (v) { S.skuId = v; S.skuLabel = ''; S.minutes = null; S.gasPeer = 0; S.gasLife = 0; S.gasLabel = ''; });

    var rateSel = calc.querySelector('#ccRegion');
    var customWrap = calc.querySelector('[data-cc-custom]');
    function syncCustom() { if (customWrap) customWrap.hidden = S.rateId !== 'custom'; }
    if (rateSel) rateSel.value = S.rateId;
    bindSelect(calc, '#ccRegion', function (v) {
      S.rateId = v;
      var r = M.RATES[v] || M.RATES.nevada;
      if (v !== 'custom') { S.elec = r.elec; S.gas = r.gas; S.gasFixed = r.gasFixed; }
      var e = calc.querySelector('#ccElec'), g = calc.querySelector('#ccGas'), f = calc.querySelector('#ccFixed');
      if (e) e.value = (S.elec * 100).toFixed(2);
      if (g) g.value = S.gas.toFixed(2);
      if (f) f.value = S.gasFixed.toFixed(2);
      syncCustom();
    });
    syncCustom();

    [['#ccElec', function (v) { S.elec = v / 100; }, function () { return (S.elec * 100).toFixed(2); }],
     ['#ccGas', function (v) { S.gas = v; }, function () { return S.gas.toFixed(2); }],
     ['#ccFixed', function (v) { S.gasFixed = v; }, function () { return S.gasFixed.toFixed(2); }]
    ].forEach(function (spec) {
      var el = calc.querySelector(spec[0]);
      if (!el) return;
      el.value = spec[2]();
      if (el.__ihBound) return;
      el.__ihBound = true;
      el.addEventListener('input', function () {
        var v = parseFloat(el.value);
        if (isFinite(v) && v >= 0) { spec[1](v); renderAll(); }
      });
    });

    var freq = calc.querySelector('#ccFreq');
    if (freq) freq.value = String(S.sessionsPerWeek);
    bindRange(calc, '#ccFreq', function (v) { S.sessionsPerWeek = v; });

    var yrs = calc.querySelector('#ccYears');
    if (yrs) yrs.value = String(S.years);
    bindRange(calc, '#ccYears', function (v) { S.years = v; });

    var chk = calc.querySelector('#ccElectrify');
    if (chk) {
      chk.checked = S.closeAccount;
      if (!chk.__ihBound) {
        chk.__ihBound = true;
        chk.addEventListener('change', function () { S.closeAccount = chk.checked; renderAll(); });
      }
    }
  }

  if (thermo && !thermo.__ihBound) {
    thermo.__ihBound = true;

    var kit = thermo.querySelector('#thKitchen');
    if (kit) kit.value = S.kitchen;
    bindSelect(thermo, '#thKitchen', function (v) { S.kitchen = v; });

    var hood = thermo.querySelector('#thHood');
    if (hood) hood.value = S.hood;
    bindSelect(thermo, '#thHood', function (v) { S.hood = v; });

    var base = thermo.querySelector('#thBase');
    if (base) base.value = String(S.baseF);
    bindRange(thermo, '#thBase', function (v) { S.baseF = v; });

    var ac = thermo.querySelector('#thAcMonths');
    if (ac) ac.value = String(S.acMonths);
    bindRange(thermo, '#thAcMonths', function (v) { S.acMonths = v; });

    var mins = thermo.querySelector('#thMinutes');
    if (mins) {
      var t0 = M.thermal(S);
      mins.max = String(Math.round(t0.spanMinutes));
      if (S.minutes == null) S.minutes = Math.round(t0.cookMinutes);
      mins.value = String(S.minutes);
      if (!mins.__ihBound) {
        mins.__ihBound = true;
        mins.addEventListener('input', function () { S.minutes = Number(mins.value); renderThermo(); });
      }
    }
  }

  var origThermo = renderThermo;
  renderThermo = function () {
    var mins = thermo && thermo.querySelector('#thMinutes');
    if (mins) {
      var t = M.thermal(S);
      var span = Math.round(t.spanMinutes);
      if (mins.max !== String(span)) mins.max = String(span);
      if (S.minutes == null || S.minutes > span) { S.minutes = Math.round(t.cookMinutes); mins.value = String(S.minutes); }
    }
    origThermo();
  };

  renderAll();
}

if (!window.__ihEnergyBound) {
  window.__ihEnergyBound = true;
  if (document.readyState !== 'loading') { ihEnergyInit(); }
  else { document.addEventListener('DOMContentLoaded', ihEnergyInit); }
  document.addEventListener('shopify:section:load', ihEnergyInit);
}
